var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.session.contents
        ? _c("div", [
            _vm._v(
              "\n    You're already logged in!\n    Click here to continue\n    Click here to log out\n  "
            )
          ])
        : [
            _c(_vm.component, { tag: "component" }),
            _vm._v(" "),
            _vm.component === "login"
              ? _c(
                  "h3",
                  [
                    _c("router-link", { attrs: { to: "/signup" } }, [
                      _vm._v("Or Signup")
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.component === "signup"
              ? _c(
                  "h3",
                  [
                    _c("router-link", { attrs: { to: "/login" } }, [
                      _vm._v("Or Login")
                    ])
                  ],
                  1
                )
              : _vm._e()
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e0db976e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e0db976e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration.vue
// module id = XiBC
// module chunks = 1